import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Request } from 'express';
import * as UAParser from 'ua-parser-js';

@Injectable()
export class UserAgent {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(REQUEST) private request: Request,
  ) {}

  isMobileDevice(): boolean {
    return this.getUserAgent().getDevice().type !== undefined;
  }

  // be careful with that, it's probably not the thing you want to use
  // everywhere, as there should be little reasons to run IE specific code.
  isBrowserIE(): boolean {
    const ua = this.getUserAgent();
    const { name } = ua.getBrowser();
    return name === 'IE';
  }

  getUserAgent() {
    if (isPlatformServer(this.platformId)) {
      return new UAParser(this.request.get('User-Agent'));
    }
    return new UAParser(window.navigator.userAgent);
  }
}
